import React, { useEffect, useState } from "react";
import { prepareHorizontalBarData } from "../../utils/svgUtils";

export default function BarGraphHorizontal({ inputData }) {
    const [preparedData, setPreparedData] = useState({
        // adjustable
        pxWidth: 1500,
        pxHeight: 350,
        opacity: 0.6, // opacity of bar color (currently don't change anything, DELETE IF NOT USED)
        color: "#ABC6C7", // color of bar value
        valueSymbol: "₴",
        // adjusted automatically depending on the data
        data: [{ label: "", values: [] }],
        widthCoefficient: 0,
        heightCoefficient: 0,
        totalSum: 0,
    });

    useEffect(() => {
        setPreparedData((prevData) =>
            prepareHorizontalBarData(prevData, inputData)
        );
    }, [inputData]);

    // Function to truncate the label with ellipsis if it exceeds maxLabelWidth
    const truncateLabel = (text, maxWidth, fontSize) => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = `${fontSize}px sans-serif`;

        let truncatedText = text;
        while (context.measureText(truncatedText).width > maxWidth) {
            truncatedText = truncatedText.slice(0, -1);
            if (truncatedText.length <= 1) break; // Prevent infinite loop for very short text
        }
        return truncatedText.length < text.length
            ? truncatedText + "..."
            : text;
    };

    return (
        <div>
            <svg
                className={`bg-white rounded rounded-4 p-1 pt-2 pb-0 bg-opacity-75${
                    preparedData.data.length === 1 && " pt-3"
                }`}
                viewBox={`0 0 ${preparedData.pxWidth} ${preparedData.pxHeight}`}
            >
                {preparedData.data.map((item, index) => {
                    const value = item.values[0];
                    const barWidth = isNaN(
                        value / preparedData.widthCoefficient
                    )
                        ? 0
                        : value / preparedData.widthCoefficient;

                    return (
                        <g key={index}>
                            {/* Label data */}
                            <text
                                x={parseInt(preparedData.pxWidth * 0.01)}
                                y={parseInt(
                                    preparedData.heightCoefficient * index +
                                        preparedData.heightCoefficient / 2
                                )}
                                textAnchor="start"
                                fontSize={preparedData.pxHeight * 0.12}
                            >
                                {truncateLabel(
                                    item.label,
                                    preparedData.pxWidth * 0.27,
                                    preparedData.pxHeight * 0.05
                                )}
                            </text>

                            {/* Paints each Bar */}
                            <rect
                                x={parseInt(preparedData.pxWidth * 0.2)}
                                y={parseInt(
                                    preparedData.heightCoefficient * index
                                )}
                                width={parseInt(barWidth)}
                                height={parseInt(
                                    preparedData.heightCoefficient * 0.75
                                )}
                                fill={preparedData.color}
                            />
                            <rect
                                x={parseInt(
                                    preparedData.pxWidth * 0.2 + barWidth
                                )}
                                y={parseInt(
                                    preparedData.heightCoefficient * index
                                )}
                                width={parseInt(
                                    preparedData.pxWidth * 0.6 - barWidth
                                )}
                                height={parseInt(
                                    preparedData.heightCoefficient * 0.75
                                )}
                                fill="#ECEDEE"
                            />

                            {/* Data */}
                            <text
                                x={parseInt(preparedData.pxWidth * 0.99)}
                                y={parseInt(
                                    preparedData.heightCoefficient * index +
                                        preparedData.heightCoefficient / 2
                                )}
                                alignmentBaseline="middle"
                                textAnchor="end"
                                fontSize={preparedData.pxHeight * 0.12}
                            >
                                {(parseFloat(value) > 1000000
                                    ? parseFloat(value)
                                    : parseFloat(value).toFixed(2)) +
                                    " " +
                                    preparedData.valueSymbol}
                            </text>
                        </g>
                    );
                })}
            </svg>
            {/* Total Sum in HTML */}
            <div
                style={{
                    textAlign: "center",
                    marginTop: "10px",
                    fontSize: "17px",
                    fontWeight: "bold",
                }}
            >
                {`Загальна сума: ${preparedData.totalSum.toFixed(2)} ${
                    preparedData.valueSymbol
                }`}
            </div>
        </div>
    );
}
